import * as React from "react";
import { Component } from "react";
import * as PropTypes from "prop-types";
import classNames from "classnames";
import { InputText } from "@bizform/primereact/inputtext";
import Tooltip from "@bizform/primereact/components/tooltip/Tooltip";
import DomHandler from "@bizform/core/dist/js/vendor/primereact/utils/DomHandler";
import { WindowKey } from "@bizform/type/model/model/WindowKey.model";
import { ExceptionType } from "@bizform/type/model/model/Exception.model";
import { ComponentHelper } from "@bizform/helper/dist/js/bizflow/helper.min";
import { I18N } from "@bizform/core/dist/js/bizflow/core.min";
import { MultipleInputMaskProps } from "./InputMask.model";


export class MultipleInputMask extends Component {

    static defaultProps = {
        // itemTemplate: null,
        id: null,
        value: null,
        max: null,
        type: "text",
        mask: null,
        slotChar: "_",
        autoClear: true,
        unmask: false,
        style: null,
        inputStyle: null,
        className: null,
        placeholder: null,
        size: null,
        maxlength: null,
        tabindex: null,
        disabled: false,
        readOnly: false,
        name: null,
        required: false,
        tooltip: null,
        tooltipOptions: null,
        onComplete: null,
        onChange: null
    };

    static propTypes = {
        // itemTemplate: PropTypes.func,

        id: PropTypes.string,
        value: PropTypes.array,
        max: PropTypes.number,
        type: PropTypes.string,
        mask: PropTypes.string,
        slotChar: PropTypes.string,
        autoClear: PropTypes.bool,
        unmask: PropTypes.bool,
        style: PropTypes.object,
        className: PropTypes.string,
        placeholder: PropTypes.string,
        size: PropTypes.number,
        maxlength: PropTypes.number,
        tabindex: PropTypes.number,
        disabled: PropTypes.bool,
        readOnly: PropTypes.bool,
        name: PropTypes.string,
        required: PropTypes.bool,
        tooltip: PropTypes.string,
        tooltipOptions: PropTypes.object,
        onComplete: PropTypes.func,
        onChange: PropTypes.func,
        onFocus: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.focusInput = this.focusInput.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onInput = this.onInput.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this._setRef = this._setRef.bind(this);
        this._placeholder = this._placeholder.bind(this);
    }

    props: MultipleInputMaskProps ;
    listElement: any;
    element: any;

    input: any;
    firstNonMaskPos: number;
    lastRequiredNonMaskPos: number;
    tests: Array<any>;
    buffer: Array<any>;
    isValueChecked: boolean;
    len: number;
    partialPosition: number;
    defaultBuffer: any;
    androidChrome: boolean;
    defs: any;
    focusText: any;
    caretTimeoutId: any;
    focus: boolean;
    oldVal: any;
    tooltip: any;
    placeholder: string;

    componentDidMount() {
        this.init();
        this.updateValue();

        if (this.props.tooltip) {
            this.renderTooltip();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.tooltip && prevProps.tooltip !== this.props.tooltip) {
            if (this.tooltip)
                this.tooltip.updateContent(this.props.tooltip);
            else
                this.renderTooltip();
        }
        this.init();
        this.updateValue();
        this._placeholder();
    }

    componentWillUnmount() {
        if (this.tooltip) {
            this.tooltip.destroy();
            this.tooltip = null;
        }
    }

    renderTooltip() {
        this.tooltip = new Tooltip({
            target: this.element,
            content: this.props.tooltip,
            options: this.props.tooltipOptions
        });
    }

    checkRemoveItem(event, index) {
        if (this.props.readOnly || this.props.disabled) {
            return;
        }
        if (event.key && event.key !== "Enter") {
            return;
        }
        let func = (result) => {
            if (result) {
                this.removeItem(event, index);
            }
            (func as any).__proto__ = null;
            func = null;
        };
        window[WindowKey.CORELIBRARY].ExceptionHandler.confirm(ExceptionType.INFO, I18N.translate("{$I._app.accessibility.component.multipleInputMask.confirmDelete}"), func);
    }

    removeItem(event, index) {
        if (this.props.readOnly || this.props.disabled) {
            return;
        }

        let values = [...this.props.value];
        const removedItem = values.splice(index, 1);

        if (this.props.onRemove) {
            this.props.onRemove({
                originalEvent: event,
                value: removedItem
            });
        }

        if (this.props.onChange) {
            this.props.onChange({
                originalEvent: event,
                value: values,
                stopPropagation: () => {},
                preventDefault: () => {},
                target: {
                    name: this.props.name,
                    id: this.props.id,
                    value : values
                }
            });
        }

        if (this.props.accessibility) {
            if (!values.length) {
                if (this.input && this.input.focus) {
                    this.input.focus();
                }
            } else {
                this.listElement.querySelector("[bf-data-value]").focus();
            }
        }
    }

    focusInput() {
        this.input.focus();
        if (this.props.focusInput) {
            this.props.focusInput();
        }
    }

    renderItem(value, index) {
        const content = value;
        if (this.props.accessibility) {
            const aria = {
                "aria-label": I18N.translate("{$I._app.accessibility.component.multipleInputMask.doDelete}")
            };
            return (
                <div className="float-left">
                    <li {...aria} bf-data-value={index} className="p-chips-token p-highlight" style={{marginTop: "1px"}} key={index} onKeyDown={(event) => this.checkRemoveItem(event, index)} onClick={(event) => this.checkRemoveItem(event, index)} tabIndex={0}>
                        <span className="p-chips-token-label">{content}</span>
                    </li>
                </div>
            );
        } else {
            return (
                <li key={index} className="p-chips-token p-highlight" style={{marginTop: "1px"}}>
                    <span className="p-chips-token-icon pi pi-fw pi-times" onClick={(event) => this.removeItem(event, index)}></span>
                    <span className="p-chips-token-label">{content}</span>
                </li>
            );
        }
    }

    renderInput() {
        if (this.props.value && this.props.value.length >= this.props.max) {
            return null;
        }
        return (
            <li className="p-chips-input-token">
                <InputText id={this.props.id} ref={this._setRef} type={"text"} name={this.props.name} style={this.props.style} className={this.props.className} placeholder={this.props.placeholder}
                           maxLength={this.props.maxlength} tabIndex={this.props.tabindex} disabled={this.props.disabled} readOnly={this.props.readOnly}
                           autoComplete={"false"} autoSave="false" onFocus={this.onFocus} onBlur={this.onBlur} onKeyDown={this.onKeyDown} onKeyPress={this.onKeyPress} onInput={this.onInput} onPaste={this.handleInputChange}/>
            </li>
        );
    }

    renderItems() {
        if (this.props.value && this.props.value.length > 0) {
            return this.props.value.map((value, index) => {
                return this.renderItem(value, index);
            });
        }
        else {
            return null;
        }
    }

    renderList() {
        const className = classNames("p-inputtext", {"p-disabled": this.props.disabled});
        const items = this.renderItems();
        const input = this.renderInput();

        if (this.props.value) {
            return (
                <ul ref={(el) => this.listElement = el} className={className} onClick={this.focusInput} onBlur={this.props.blurEvent}>
                    {items}
                    {input}
                </ul>
            );
        }
        else {
            return null;
        }
    }

    render() {
        const className = classNames("p-chips p-component", this.props.className);
        const list = this.renderList();

        return (
            <div ref={(el) => this.element = el} id={this.props.id} className={className} style={this.props.style}>
                {list}
            </div>
        );
    }

    caret(first?, last?) {
        let range, begin, end;

        if (!this.input.offsetParent || this.input !== document.activeElement) {
            return;
        }

        if (typeof first === "number") {
            begin = first;
            end = (typeof last === "number") ? last : begin;
            if (this.input.setSelectionRange) {
                this.input.setSelectionRange(begin, end);
            }
            else if (this.input["createTextRange"]) {
                range = this.input["createTextRange"]();
                range.collapse(true);
                range.moveEnd("character", end);
                range.moveStart("character", begin);
                range.select();
            }
        }
        else {
            if (this.input.setSelectionRange) {
                begin = this.input.selectionStart;
                end = this.input.selectionEnd;
            }
            else if (document["selection"] && document["selection"].createRange) {
                range = document["selection"].createRange();
                begin = 0 - range.duplicate().moveStart("character", -100000);
                end = begin + range.text.length;
            }

            return { begin: begin, end: end };
        }
    }

    isCompleted() {
        for (let i = this.firstNonMaskPos; i <= this.lastRequiredNonMaskPos; i++) {
            if (this.tests[i] && this.buffer[i] === this.getPlaceholder(i)) {
                return false;
            }
        }

        return true;
    }

    getPlaceholder(i) {
        if (i < this.props.slotChar.length) {
            return this.props.slotChar.charAt(i);
        }
        return this.props.slotChar.charAt(0);
    }

    seekNext(pos) {
        while (++pos < this.len && !this.tests[pos]);
        return pos;
    }

    seekPrev(pos) {
        while (--pos >= 0 && !this.tests[pos]);
        return pos;
    }

    shiftL(begin, end) {
        let i, j;

        if (begin < 0) {
            return;
        }

        for (i = begin, j = this.seekNext(end); i < this.len; i++) {
            if (this.tests[i]) {
                if (j < this.len && this.tests[i].test(this.buffer[j])) {
                    this.buffer[i] = this.buffer[j];
                    this.buffer[j] = this.getPlaceholder(j);
                } else {
                    break;
                }

                j = this.seekNext(j);
            }
        }
        this.writeBuffer();
        this.caret(Math.max(this.firstNonMaskPos, begin));
    }

    shiftR(pos) {
        let i, c, j, t;

        for (i = pos, c = this.getPlaceholder(pos); i < this.len; i++) {
            if (this.tests[i]) {
                j = this.seekNext(i);
                t = this.buffer[i];
                this.buffer[i] = c;
                if (j < this.len && this.tests[j].test(t)) {
                    c = t;
                } else {
                    break;
                }
            }
        }
    }

    onBlur(e) {
        if (!this.props.accessibility) {
            DomHandler.removeClass(this.listElement, "p-focus");
        }

        this.focus = false;
        this.checkVal();
        this.updateFilledState();

        if (this.getUnmaskedValue() === "") {
            if (this.input.value) this.input.value = "";
            this.clearBuffer(0, this.len);
        }
    }

    onKeyDown(e) {
        if (this.props.readOnly) {
            return;
        }

        let k = e.which || e.keyCode,
            pos,
            begin,
            end;
        let iPhone = /iphone/i.test(DomHandler.getUserAgent());
        this.oldVal = this.input.value;

        // backspace, delete, and escape get special treatment
        if (k === 8 || k === 46 || (iPhone && k === 127)) {
            if (k === 8 && this.getUnmaskedValue().length === 0) {
                if (!this.props.accessibility && this.props.value && this.props.value.length > 0) {
                    this.removeItem(e, this.props.value.length - 1);
                }
            }

            pos = this.caret();
            begin = pos.begin;
            end = pos.end;

            if (end - begin === 0) {
                begin = k !== 46 ? this.seekPrev(begin) : (end = this.seekNext(begin - 1));
                end = k === 46 ? this.seekNext(end) : end;
            }

            this.clearBuffer(begin, end);
            this.shiftL(begin, end - 1);

            e.preventDefault();
        } else if (k === 13) { // enter
            this.onBlur(e);
        } else if (k === 27) { // escape
            this.input.value = this.focusText;
            this.caret(0, this.checkVal());
            e.preventDefault();
        } else {
            if (this.props.max === this.props.value.length) {
                e.preventDefault();
            }
        }
    }

    onKeyPress(e) {
        if (this.props.readOnly) {
            return;
        }

        let k = e.which || e.keyCode,
            pos = this.caret(),
            p,
            c,
            next,
            completed;

        if (e.ctrlKey || e.altKey || e.metaKey || k < 32) {// Ignore
            return;
        } else if (k && k !== 13) {
            if (pos.end - pos.begin !== 0) {
                this.clearBuffer(pos.begin, pos.end);
                this.shiftL(pos.begin, pos.end - 1);
            }

            p = this.seekNext(pos.begin - 1);
            if (p < this.len) {
                c = String.fromCharCode(k);
                if (this.tests[p].test(c)) {
                    this.shiftR(p);

                    this.buffer[p] = c;
                    this.writeBuffer();
                    next = this.seekNext(p);

                    if (/android/i.test(DomHandler.getUserAgent())) {
                        // Path for CSP Violation on FireFox OS 1.1
                        let proxy = () => {
                            this.caret(next);
                        };

                        setTimeout(proxy, 0);
                    } else {
                        this.caret(next);
                    }
                    if (pos.begin <= this.lastRequiredNonMaskPos) {
                        completed = this.isCompleted();
                    }
                }
            }
            e.preventDefault();
        }

        if (completed) {
            const inputValue = e.target.value;
            if (inputValue && inputValue.trim().length && (!this.props.max || this.props.max >= this.props.value.length)) {
                let values = [...this.props.value];
                const duplicated = values.find( (val) => {
                    return val === e.target.value;
                });
                if (duplicated && this.props.accessibility) {
                    window[WindowKey.CORELIBRARY].ExceptionHandler.toast(ExceptionType.INFO, I18N.translate("{$I._app.accessibility.component.multipleInputMask.duplicated}"));
                    return;
                }
                if (!duplicated) {
                    values.push(inputValue);
                    this.setState({values: values});

                    if (this.props.onAdd) {
                        if (window[WindowKey.CORELIBRARY].DataStorage.accessibility) {
                            window[WindowKey.CORELIBRARY].ExceptionHandler.toast(ExceptionType.INFO, I18N.translate("{$I._app.accessibility.component.multipleInputMask.addedValue}", {value: inputValue}));
                        }
                        this.props.onAdd({
                            originalEvent: event,
                            value: inputValue
                        });
                    }

                    if (this.props.onChange) {
                        this.props.onChange({
                            originalEvent: event,
                            value: values,
                            stopPropagation : () => {},
                            preventDefault : () => {},
                            target: {
                                name: this.props.name,
                                id: this.props.id,
                                value : values
                            }
                        });
                    }
                }
            }
        }
    }

    clearBuffer(start, end) {
        let i;
        for (i = start; i < end && i < this.len; i++) {
            if (this.tests[i]) {
                this.buffer[i] = this.getPlaceholder(i);
            }
        }
    }

    writeBuffer() {
        this.input.value = this.buffer.join("");
    }

    checkVal(allow?) {
        this.isValueChecked = true;
        // try to place characters where they belong
        let test = this.input.value,
            lastMatch = -1,
            i,
            c,
            pos;

        for (i = 0, pos = 0; i < this.len; i++) {
            if (this.tests[i]) {
                this.buffer[i] = this.getPlaceholder(i);
                const maskTokens = this.props.mask.split("");
                while (pos++ < test.length) {
                    c = test.charAt(pos - 1);
                    if (this.tests[i].test(c)) {
                        this.buffer[i] = c;
                        lastMatch = i;
                        break;
                    }
                }
                if (pos > test.length) {
                    this.clearBuffer(i + 1, this.len);
                    break;
                }
            } else {
                if (this.buffer[i] === test.charAt(pos)) {
                    pos++;
                }
                if (i < this.partialPosition) {
                    lastMatch = i;
                }
            }
        }
        if (allow) {
            this.writeBuffer();
        } else if (lastMatch + 1 < this.partialPosition) {
            if (this.props.autoClear || this.buffer.join("") === this.defaultBuffer) {
                // Invalid value. Remove it and replace it with the
                // mask, which is the default behavior.
                if (this.input.value) this.input.value = "";
                this.clearBuffer(0, this.len);
            } else {
                // Invalid value, but we opt to show the value to the
                // user and allow them to correct their mistake.
                this.writeBuffer();
            }
        } else {
            this.writeBuffer();
            this.input.value = this.input.value.substring(0, lastMatch + 1);
        }
        return (this.partialPosition ? i : this.firstNonMaskPos);
    }

    onFocus(event) {
        if (this.props.readOnly) {
            return;
        }

        if (!this.props.accessibility) {
            DomHandler.addClass(this.listElement, "p-focus");
        }

        this.focus = true;

        clearTimeout(this.caretTimeoutId);
        let pos;

        this.focusText = this.input.value;

        pos = this.checkVal();

        this.caretTimeoutId = setTimeout(() => {
            if (this.input !== document.activeElement) {
                return;
            }
            this.writeBuffer();
            if (pos === this.props.mask.replace("?", "").length) {
                this.caret(0, pos);
            } else {
                this.caret(pos);
            }
            this.updateFilledState();
        }, 10);
    }

    onInput(event) {
        if (this.androidChrome)
            this.handleAndroidInput(event);
        else
            this.handleInputChange(event);
    }

    handleAndroidInput(e) {
        const curVal = this.input.value;
        const pos = this.caret();
        if (this.oldVal && this.oldVal.length && this.oldVal.length > curVal.length) {
            // a deletion or backspace happened
            this.checkVal(true);
            while (pos.begin > 0 && !this.tests[pos.begin - 1])
                pos.begin--;
            if (pos.begin === 0) {
                while (pos.begin < this.firstNonMaskPos && !this.tests[pos.begin])
                    pos.begin++;
            }
            this.caret(pos.begin, pos.begin);
        } else {
            this.checkVal(true);
            while (pos.begin < this.len && !this.tests[pos.begin])
                pos.begin++;

            this.caret(pos.begin, pos.begin);
        }

        if (this.props.onComplete && this.isCompleted()) {
            this.props.onComplete(e);
        }
    }

    handleInputChange(event?: any) {
        if (this.props.readOnly) {
            return;
        }

        this.checkVal();
        this.updateFilledState();

        if (this.getUnmaskedValue() === "") {
            if (this.input.value) this.input.value = "";
            this.clearBuffer(0, this.len);
        }

        if (event) {
            if (this.isCompleted()) {
                const inputValue = event ? event.target.value : this.input.value;
                if (inputValue && inputValue.trim().length && (!this.props.max || this.props.max >= this.props.value.length)) {
                    let values = [...this.props.value];
                    const duplicated = values.find((val) => {
                        return val === event ? event.target.value : this.input.value;
                    });
                    if (!duplicated) {
                        values.push(inputValue);
                        this.setState({values: values});

                        if (this.props.onAdd) {
                            this.props.onAdd({
                                originalEvent: event,
                                value: inputValue
                            });
                        }

                        if (this.props.onChange) {
                            this.props.onChange({
                                originalEvent: event,
                                value: values,
                                stopPropagation: () => {
                                },
                                preventDefault: () => {
                                },
                                target: {
                                    name: this.props.name,
                                    id: this.props.id,
                                    value: values
                                }
                            });
                        }
                    }
                }
            }
        }
    }

    getMaskedValue(unmaskValue: string): string {
        if (this.props.readOnly) {
            return;
        }

        const unmaskBuffer = unmaskValue.split("");
        this.clearBuffer(0, this.len);
        for (let i = 0; i < this.buffer.length; i++) {
            if (this.tests[i] && this.buffer[i] === this.getPlaceholder(i)) {
                let c = unmaskBuffer.length > 0 ? unmaskBuffer.shift() : "";
                this.buffer[i] = c;
            }
        }
        const returnValue = this.buffer.join("");
        this.clearBuffer(0, this.len);
        return returnValue;
    }

    getUnmaskedValue() {
        let unmaskedBuffer = [];
        for (let i = 0; i < this.buffer.length; i++) {
            let c = this.buffer[i];
            if (this.tests[i] && c !== this.getPlaceholder(i)) {
                unmaskedBuffer.push(c);
            }
        }

        return unmaskedBuffer.join("");
    }

    getUnmaskedValueFromData(data: string) {
        const splitData = data.split("");
        let unmaskedBuffer = [];
        for (let i = 0; i < splitData.length; i++) {
            let c = splitData[i];
            if (this.tests[i] && c !== this.getPlaceholder(i)) {
                unmaskedBuffer.push(c);
            }
        }

        return unmaskedBuffer.join("");
    }

    updateFilledState() {
        if (this.input && this.input.value && this.input.value.length > 0)
            DomHandler.addClass(this.input, "p-filled");
        // else
        //     DomHandler.removeClass(this.input, "p-filled");
    }

    updateValue() {
        if (this.input) {
            this.input.value = "";
            setTimeout(() => {
                if (this.input) {
                    if (this.input.value) this.input.value = "";
                    this.clearBuffer(0, this.len);
                }
            }, 10);

            this.focusText = this.input.value;
        }

        this.updateFilledState();
    }

    init() {
        this.tests = [];
        this.partialPosition = this.props.mask.length;
        this.len = this.props.mask.length;
        this.firstNonMaskPos = null;
        this.defs = {
            "9": "[0-9]",
            "a": "[A-Za-z]",
            "*": "[A-Za-z0-9]"
        };

        let ua = DomHandler.getUserAgent();
        this.androidChrome = /chrome/i.test(ua) && /android/i.test(ua);

        let output = "";
        this.buffer = [];
        for (let i = 0; i < this.props.mask.length; i++) {
            const c = this.props.mask.charAt(i);
            if (c === "?") {
                this.len--;
                this.partialPosition = i;
            } else if (this.defs[c]) {
                this.tests.push(new RegExp(this.defs[c]));

                if (this.firstNonMaskPos === null) {
                    this.firstNonMaskPos = this.tests.length - 1;
                }

                if (i < this.partialPosition) {
                    this.lastRequiredNonMaskPos = this.tests.length - 1;
                }
            } else {
                this.tests.push(null);
            }

            if (c !== "?") {
                if (this.defs[c]) {
                    this.buffer.push(this.getPlaceholder(i));
                } else {
                    this.buffer.push(c);
                }
            }
        }
        this.defaultBuffer = this.buffer.join("");
    }

    private _formatType(match, index) {
        let num = 0;
        while (num < 2) {
            this.buffer.push(match);
            num++;
        }

        if (this.firstNonMaskPos === null) {
            this.firstNonMaskPos = this.tests.length - 2;
        }

        if (index < this.partialPosition) {
            this.lastRequiredNonMaskPos = this.tests.length - 1;
        }
    }

    private _setRef(ref) {
        if (ref) {
            this.input = ref.element;
            this._placeholder();
        }
    }

    private _placeholder() {
        if (this.input && this.placeholder !== this.props.placeholder) {
            this.placeholder = this.props.placeholder;
            ComponentHelper.setInputSize(this.input, this.props.placeholder, 100);
        }
    }
}